export default "__VITE_ASSET__4RCc74_Y__"